import MatchedMap from 'utilities/src/matchedMap';

import { InputSizeEnum } from '../../../utils/size';
import { InputThemeEnum, type InputThemeProps } from '../../../utils/themes';

/**
 * LabelTop Common Classes
 *
 */

const labelTopSizeClassesMap = new MatchedMap([
  [InputSizeEnum.Small, 'site-paragraph-s'],
  [InputSizeEnum.Medium, 'site-paragraph-m'],
  [InputSizeEnum.Large, 'site-paragraph-m'],
]);

const labelTopClasses = 'leading-5';

const labelTopOptionalClasses = 'paragraph-xs italic';

/**
 * LabelTop Theme Classes
 */

const labelTopBgThemeClassesMap = new MatchedMap([
  [InputThemeEnum.Dark, 'text-white'],
  [InputThemeEnum.Light, 'text-neutrals-900'],
]);

/**
 * Blog Theme
 */

const inputLabelTopBlogTheme = ({ inputTheme, inputSize }: Pick<InputThemeProps, 'inputTheme' | 'inputSize'>) => ({
  labelTopThemeClasses: labelTopClasses,
  labelTopOptionalThemeClasses: labelTopOptionalClasses,
  labelTopColorThemeClasses: labelTopBgThemeClassesMap.get(InputThemeEnum[inputTheme]),
  labelTopSizeClasses: labelTopSizeClassesMap.get(InputSizeEnum[inputSize]),
});

export default inputLabelTopBlogTheme;
